// Utils and Service

import { getErrorMessage } from '../utils/helpers'

import axios from './instance'

/**
 * Gets the manufacturers for the specified manufacturerId and repair order status.
 * @param {string} manufacturerId
 * @param {func} setLoading
 * @param {func} setError
 */
export const getManufacturerActions = async (
  manufacturerId,
  setLoading = () => {},
  setError = () => {},
) => {
  setLoading(true)

  try {
    const response = await axios.get(`/manufacturers/${manufacturerId}/actions/`)
    setLoading(false)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}
